// Hardcoded client-specific URLs for invoice portals
const CLIENT_PORTAL_URLS = [
  {
    match: (client) => typeof client === 'string' && client.toLowerCase().includes('reno'),
    url: 'https://propertiesreno.appfolio.com/bulk_invoicing/intermediate_invoices',
    label: 'Go to Reno AppFolio Bulk Invoicing',
  },
  // Add more client/url objects here as needed
];

export default CLIENT_PORTAL_URLS;
